var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 323,
    viewBox: "0 0 455 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.211 121H245.724C237.04 121 230 128.04 230 136.724V285.858C230 294.542 237.04 301.582 245.724 301.582H439.211C447.896 301.582 454.936 294.542 454.936 285.858V136.724C454.936 128.04 447.896 121 439.211 121Z",
    fill: "#F5EBDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.075 122.39C442.195 122.39 446.146 124.025 449.059 126.935C451.972 129.845 453.609 133.793 453.609 137.908V285.092C453.609 289.207 451.972 293.155 449.059 296.065C446.146 298.975 442.195 300.61 438.075 300.61H246.925C242.805 300.61 238.854 298.975 235.941 296.065C233.028 293.155 231.391 289.207 231.391 285.092V137.908C231.391 133.793 233.028 129.845 235.941 126.935C238.854 124.025 242.805 122.39 246.925 122.39H438.075ZM438.075 121H246.925C242.438 121.005 238.136 122.787 234.962 125.957C231.789 129.127 230.005 133.425 230 137.908V285.092C230.005 289.575 231.789 293.873 234.962 297.043C238.136 300.213 242.438 301.995 246.925 302H438.075C442.562 301.995 446.864 300.213 450.038 297.043C453.211 293.873 454.995 289.575 455 285.092V137.908C454.995 133.425 453.211 129.127 450.038 125.957C446.864 122.787 442.562 121.005 438.075 121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.271 196.456C383.271 196.456 375.53 196.879 369.758 193.667C364.29 190.623 363.409 185.856 365.316 176.422C365.316 176.422 361.898 174.393 362.24 172.364C362.462 171.028 366.341 169.659 366.341 169.659C366.826 167.082 367.441 163.187 368.439 159.204C370.936 159.689 373.472 159.947 376.016 159.975C383.644 168.465 391.972 168.983 391.972 168.983C393.178 167.2 394.814 165.742 396.733 164.742L408.11 169.229C408.218 169.593 408.307 169.962 408.376 170.335C409.958 179.211 398.807 182.508 398.807 182.508C401.056 191.009 408.376 194.343 413.871 195.652L413.407 199.875H382.697L383.271 196.456Z",
    fill: "#EAA58B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.716 263.784C283.06 256.006 281.351 193.789 281.351 193.789L295.257 176.084C295.257 176.084 292.629 163.356 295.363 160.989C298.664 158.132 302.823 167.076 307.324 178.234C312.054 189.958 320.888 224.438 321.571 226.805C321.571 226.805 328.201 223.721 336.058 220.137L337.172 223.762L347.309 257.572C336.195 262.073 320.444 266.915 309.716 263.784Z",
    fill: "#EAA58B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M398.807 182.508C398.807 182.508 409.958 179.211 408.376 170.335C408.307 169.962 408.218 169.593 408.11 169.229L416.397 172.486C416.397 172.719 416.359 172.939 416.342 173.162L413.871 195.652C408.366 194.343 401.056 191.009 398.807 182.508Z",
    fill: "#A15842"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.972 168.983C391.972 168.983 383.644 168.465 376.016 159.975C373.472 159.948 370.936 159.689 368.439 159.204C368.863 157.513 369.359 155.806 369.946 154.172L396.733 164.743C394.814 165.743 393.178 167.2 391.972 168.983Z",
    fill: "#A15842"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.11 169.23L396.733 164.743C401.432 162.383 406.589 164.104 408.11 169.23Z",
    fill: "#30242A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M396.733 164.743L369.946 154.172C370.879 151.572 372.041 149.168 373.518 147.342C379.239 140.265 393.284 135.128 405.683 144.092C417.621 152.725 416.893 166.443 416.397 172.496L408.11 169.226C406.589 164.103 401.432 162.382 396.733 164.743Z",
    fill: "#30242A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M364.8 214.754L365.613 207.795C375.025 205.079 381.826 204.948 381.826 204.948L382.68 199.875H413.407L412.925 204.271C415.97 204.262 419.009 204.519 422.009 205.039L417.709 214.754H364.8Z",
    fill: "#4756DF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.766 235.042H362.424L363.61 224.897H413.243L408.766 235.042Z",
    fill: "#4756DF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M404.285 245.186L399.808 255.33H360.124L360.531 251.489L360.497 251.506L361.238 245.186H404.285Z",
    fill: "#4756DF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M392.314 270.763C392.314 270.763 370.042 272.231 358.139 274.144L359.055 265.475H394.73L392.314 270.763Z",
    fill: "#4756DF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.61 224.898L364.8 214.753H417.72L413.243 224.898H363.61Z",
    fill: "#FFB494"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.766 235.042L404.285 245.186H361.239L362.424 235.042H408.766Z",
    fill: "#FFB494"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M398.807 256.561L394.73 265.474H359.055L360.124 255.33H399.388L398.807 256.561Z",
    fill: "#FFB494"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M336.082 220.122C339.965 218.351 344.144 216.444 347.968 214.753C351.321 213.258 354.403 211.906 356.772 210.912C359.654 209.699 362.606 208.658 365.613 207.794L364.8 214.753L363.61 224.897L362.424 235.041L361.239 245.185L360.497 251.505C360.155 251.681 357.144 253.287 352.582 255.33C351.065 256.006 349.376 256.736 347.562 257.473L347.316 257.571L337.172 223.757L336.058 220.133L336.082 220.122Z",
    fill: "#4756DF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M394.73 265.474L398.807 256.561L399.388 255.33H399.809L398.913 257.359L432.217 269.343C426.605 280.4 420.255 289.888 415.553 294.432C399.149 310.325 356.191 300.424 356.191 300.424C356.191 300.424 351.304 304.238 344.811 305.591C333.191 328.246 326.8 320.374 326.8 320.374C326.8 320.374 322.699 324.77 319.623 320.036C313.472 320.374 313.814 316.655 319.282 303.806C313.13 311.245 307.006 311.363 306.876 309.311C306.534 303.9 321.913 285.979 336.028 280.136C344.517 276.623 358.139 274.144 358.139 274.144C370.042 272.247 392.314 270.763 392.314 270.763L394.73 265.474Z",
    fill: "#EAA58B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M422.009 205.039C428.348 206.114 436.478 208.667 441.174 214.754C443.262 217.459 444.674 220.84 444.933 225.114C445.709 237.426 439.612 254.749 432.206 269.343L398.913 257.359L422.009 205.039Z",
    fill: "#4756DF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M388.999 200.335L388.315 206.3",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M394.809 200.335L394.125 206.3",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M383.251 197.17C385.483 197.005 387.665 196.432 389.686 195.479",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M318.544 303.637C319.859 300.749 321.366 297.618 322.723 295.244",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M329.141 298.612C324.873 306.031 321.575 314.383 319.572 320.019",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M336.714 303.007C333.639 308.59 330.143 315.326 327.62 320.344",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.087 251.364L361.32 238.762",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.344 226.669L324.647 235.596",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M413.065 203.595H408.824",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M381.098 204.981L380.455 208.788",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M373.757 146.541L416.817 162.772",
    stroke: "#4756DF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M392.895 269.961L402.225 269.41",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M392.553 270.299L405.406 242.142",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M294.084 173.129C294.87 176.196 295.971 180.23 297.071 183.307C297.071 183.307 291.262 193.451 297.413 205.286",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M280.356 273.17H295.185C295.286 273.17 295.384 273.131 295.456 273.059C295.527 272.988 295.568 272.892 295.568 272.792V262.039C295.568 261.938 295.527 261.842 295.456 261.771C295.384 261.7 295.286 261.66 295.185 261.66H280.356C278.815 261.66 277.338 262.266 276.248 263.344C275.159 264.422 274.546 265.884 274.546 267.409C274.545 268.165 274.694 268.913 274.985 269.612C275.276 270.311 275.704 270.947 276.243 271.482C276.783 272.017 277.424 272.442 278.13 272.732C278.836 273.021 279.592 273.17 280.356 273.17V273.17Z",
    stroke: "#A15842",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M299.614 259.908C311.852 259.908 317.511 250.258 317.511 250.258L309.282 285.671H289.946L281.72 250.258C283.63 253.237 286.274 255.685 289.405 257.374C292.535 259.062 296.049 259.934 299.614 259.908Z",
    fill: "#FF7235"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M299.614 259.908C296.049 259.934 292.535 259.062 289.405 257.374C286.274 255.685 283.63 253.237 281.72 250.258H317.511C317.511 250.258 311.852 259.908 299.614 259.908Z",
    fill: "#A15842"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M396.521 175.192L401.647 171.472",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M372.366 171.018C371.583 171.018 370.948 170.39 370.948 169.615C370.948 168.84 371.583 168.212 372.366 168.212C373.149 168.212 373.784 168.84 373.784 169.615C373.784 170.39 373.149 171.018 372.366 171.018Z",
    fill: "#30242A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M425.727 175.618L360.606 151.187",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M373.73 179.171C373.388 179.847 371.484 181.403 369.646 180.344",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M282.451 205.644C283.278 204.819 283.914 203.425 283.743 201.228C283.743 201.228 286.819 202.918 288.869 201.228C291.562 199.006 290.578 195.817 290.578 195.817C290.578 195.817 293.654 196.832 295.021 194.465C296.504 191.898 294.679 188.378 294.679 188.378C294.679 188.378 297.136 188.716 297.755 186.349C298.541 183.353 296.897 180.628 295.168 178.657",
    stroke: "#A15842",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M336.071 142.309L287.59 124.088C284.28 122.843 282.616 119.18 283.874 115.905L297.196 81.2033C298.454 77.9283 302.156 76.2818 305.466 77.5259L353.947 95.7474C357.257 96.9914 358.921 100.655 357.664 103.93L344.341 138.632C343.084 141.907 339.381 143.553 336.071 142.309Z",
    fill: "#30242A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M278.868 226.034C278.332 227.431 276.753 228.133 275.342 227.603C273.93 227.072 273.22 225.51 273.757 224.113L309.108 132.033C309.644 130.636 311.223 129.934 312.635 130.465C314.046 130.995 314.756 132.558 314.22 133.954L278.868 226.034Z",
    fill: "#30242A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M315.037 99.1506C316.608 98.484 318.382 98.4614 319.97 99.0878C321.558 99.7141 322.829 100.938 323.506 102.491L324.251 104.209L325.987 103.469C327.552 102.826 329.31 102.82 330.88 103.45C332.449 104.08 333.705 105.297 334.376 106.837C335.046 108.376 335.076 110.115 334.461 111.677C333.845 113.239 332.633 114.498 331.086 115.182L329.35 115.922L317.515 120.967L312.413 109.254L311.668 107.54C311.331 106.77 311.151 105.942 311.138 105.104C311.125 104.265 311.28 103.433 311.593 102.653C311.906 101.874 312.371 101.163 312.962 100.562C313.553 99.9612 314.258 99.4815 315.037 99.1506Z",
    fill: "#FFB494"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M285.694 172.527C282.513 174.417 283.196 178.079 283.196 178.079C283.196 178.079 276.795 177.21 276.983 183.685C276.983 183.685 271.881 186.005 274.222 191.053C274.222 191.053 270.712 191.959 272.465 197.508C274.174 202.919 277.67 206.33 279.984 206.638C281.207 206.8 284.085 205.624 283.743 201.228C283.743 201.228 286.819 202.919 288.869 201.228C291.562 199.006 290.578 195.818 290.578 195.818C290.578 195.818 293.654 196.832 295.021 194.465C296.504 191.899 294.679 188.379 294.679 188.379C294.679 188.379 297.136 188.717 297.755 186.35C299.067 181.355 293.623 177.115 292.287 175.867L293.312 173.162C293.312 173.162 288.869 170.64 285.694 172.527Z",
    fill: "#EAA58B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M295.872 189.599C291.993 187.34 286.115 183.175 282.813 178.19",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M291.368 196.64C285.734 193.41 280.772 189.149 276.747 184.084",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M283.535 201.658C280.801 199.629 277.041 195.909 273.87 191.632",
    stroke: "#A15842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M248.211 1H54.7244C46.04 1 39 8.04003 39 16.7244V165.858C39 174.542 46.04 181.582 54.7244 181.582H248.211C256.896 181.582 263.936 174.542 263.936 165.858V16.7244C263.936 8.04003 256.896 1 248.211 1Z",
    fill: "#F5EBDD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M247.999 1.39731C252.138 1.39731 256.106 3.04135 259.033 5.96776C261.959 8.89417 263.603 12.8632 263.603 17.0018V164.998C263.603 169.137 261.959 173.106 259.033 176.032C256.106 178.959 252.138 180.603 247.999 180.603H56.0006C51.8624 180.603 47.8936 178.959 44.9674 176.032C42.0411 173.106 40.3972 169.137 40.3972 164.998V17.0018C40.3972 12.8632 42.0411 8.89417 44.9674 5.96776C47.8936 3.04135 51.8624 1.39731 56.0006 1.39731H247.999ZM247.999 0H56.0006C51.4932 0.0046238 47.1717 1.79737 43.9845 4.98482C40.7972 8.17228 39.0046 12.4941 39 17.0018V164.998C39.0046 169.506 40.7972 173.828 43.9845 177.015C47.1717 180.203 51.4932 181.995 56.0006 182H247.999C252.507 181.995 256.828 180.203 260.016 177.015C263.203 173.828 264.995 169.506 265 164.998V17.0018C264.995 12.4941 263.203 8.17228 260.016 4.98482C256.828 1.79737 252.507 0.0046238 247.999 0Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1589 76.6709H202.3V86.8151H34.1589V76.6709Z",
    fill: "#FFB494"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M133.942 67.1465L130.191 77.3105L171.602 92.2723C172.964 92.7645 174.468 92.7011 175.783 92.096C177.098 91.491 178.116 90.3939 178.614 89.046C179.111 87.6982 179.047 86.2101 178.436 84.909C177.824 83.6079 176.715 82.6005 175.353 82.1083L133.942 67.1465Z",
    fill: "#30242A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M166.621 78.9536L162.869 89.1176L171.601 92.2724C172.963 92.7645 174.467 92.7011 175.782 92.0961C177.097 91.491 178.116 90.3939 178.613 89.0461C179.11 87.6983 179.046 86.2101 178.435 84.909C177.823 83.608 176.714 82.6005 175.352 82.1083L166.621 78.9536Z",
    fill: "#30242A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.953 81.8577C119.347 81.8577 113.992 76.5591 113.992 70.0229C113.992 63.4866 119.347 58.188 125.953 58.188C132.559 58.188 137.915 63.4866 137.915 70.0229C137.915 76.5591 132.559 81.8577 125.953 81.8577Z",
    fill: "#4756DF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M178.484 88.9659C192.837 94.038 210.824 101.531 222.57 86.9371C237.265 68.6776 208.558 49.7418 200.698 73.7497C191.833 100.828 246.041 119.882 232.139 144.421C219.494 166.738 179.687 142.689 156.612 150.845C137.474 157.608 136.975 180.686 136.975 180.686",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M139.76 69.2322C140.443 65.1745 143.177 62.1313 144.886 61.7289C148.963 60.7753 151.215 64.434 151.215 64.434C151.215 64.434 154.442 61.5091 158.953 65.4315C158.953 65.4315 164.12 63.8355 166.352 68.4274C166.352 68.4274 168.648 67.5685 171.198 72.2687C173.272 76.0998 174.957 81.838 172.565 83.4272C171.539 84.1035 168.464 83.7654 167.438 81.3984C167.438 81.3984 166.516 83.0891 164.704 82.751C160.945 82.0747 160.603 79.0314 160.603 79.0314C160.603 79.0314 160.285 80.1777 158.211 80.384C154.848 80.7221 153.085 77.3407 153.085 77.3407C153.085 77.3407 151.81 78.1827 149.326 77.3407C146.007 76.2147 145.149 71.3016 145.149 71.3016L139.76 69.2322Z",
    fill: "#A15842"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3571 124.342C4.63705 118.444 5.56292 108.381 12.4251 101.865C19.2874 95.3498 29.4874 94.8489 35.2074 100.747C40.9275 106.644 40.0016 116.707 33.1394 123.223C26.2772 129.739 16.0772 130.239 10.3571 124.342Z",
    fill: "#30242A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3104 114.543C40.3104 114.543 28.3491 107.104 26.6404 93.5781",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5151 103.493C73.6425 94.5226 77.6981 85.2489 85.5736 82.7801C93.4491 80.3112 102.162 85.5821 105.035 94.5529C107.907 103.524 103.852 112.797 95.9763 115.266C88.1008 117.735 79.3877 112.464 76.5151 103.493Z",
    fill: "#30242A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0202 98.3863C30.3312 97.3144 11.5144 108.784 15.3249 112.588C18.9202 116.159 28.455 103.803 30.0202 98.3863Z",
    fill: "#4756DF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M29.87 99.0526C30.4851 97.744 14.2622 81.3545 11.5453 85.9227C8.93432 90.3185 29.2548 100.358 29.87 99.0526Z",
    fill: "#4756DF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5124 101.355C52.9552 100.002 62.5242 99.3262 67.9922 98.6499C79.6118 92.5634 76.536 76.6709 76.536 76.6709C75.8525 76.3328 64.7285 74.3344 66.263 65.7389C67.63 57.9617 76.8812 57.9617 81.9596 63.453C81.9596 63.453 89.1808 60.4402 91.2313 50.6342C91.2313 50.6342 97.3281 51.3274 101.556 50.2217C102.475 54.2422 102.704 58.6481 103.534 63.1454C103.534 63.1454 107.977 63.4835 108.319 65.1742C108.661 66.9596 105.147 69.0695 105.147 69.0695C107.54 77.665 107.198 85.4558 101.826 88.5058C97.0411 91.2109 91.2313 90.1965 91.2313 90.1965L91.9148 98.3118C97.8995 98.5354 103.798 99.7943 109.344 102.031C120.687 106.603 147.278 124.01 147.278 124.01C145.228 117.248 136.817 95.9178 133.608 82.4193C132.241 76.6709 130.874 71.2607 134.292 70.9225C138.031 70.5506 143.519 82.0811 143.519 82.0811L166.758 90.5346C180.459 108.872 196.491 150.385 175.644 160.868C156.847 170.335 114.812 147.342 114.812 147.342L118.571 181.156H50.2212L34.8424 109.132C34.8424 109.132 34.7775 109.065 34.6613 108.933C39.4663 104.821 45.2521 102.346 48.5124 101.355Z",
    fill: "#A15842"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M57.398 94.7144H91.6107L91.9148 98.3122C94.58 98.3866 97.2332 98.6943 99.8435 99.2319C100.715 99.4043 101.638 99.6072 102.598 99.8473C104.895 100.421 107.149 101.151 109.344 102.032C109.826 102.224 110.342 102.448 110.879 102.684C111.87 103.131 112.929 103.645 114.088 104.216C121.798 108.088 132.399 114.566 139.531 119.054L130.27 137.377L125.622 146.575L123.144 151.474C118.059 149.107 114.812 147.342 114.812 147.342L118.571 181.156H50.2212L34.8424 109.133C34.022 108.227 33.2628 107.269 32.5698 106.265V106.167L57.398 94.7144Z",
    fill: "#FFBE21"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M106.166 104.287L110.879 102.684C111.87 103.13 112.929 103.644 114.088 104.216L110.226 110.468L117.898 120.822L107.782 116.683L102.147 126.966L101.504 115.645L91.7371 113.575L100.11 108.398L99.8434 99.2314C100.715 99.4039 101.638 99.6068 102.598 99.8469L106.166 104.287Z",
    fill: "#FF7235"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M123.247 143.136L114.88 141.902L114.788 139.433L119.118 137.475L115.543 126.939L125.089 133.15L131.09 126.388L130.222 137.36L130.27 137.377L125.622 146.575L123.247 143.136Z",
    fill: "#FF7235"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5451 114.85L66.7073 127.618L62.8728 114.85L50.662 111.398L62.5242 106.566V95.522L69.1507 104.148L78.5694 99.6608L72.9886 108.98L81.7067 116.23L70.5451 114.85Z",
    fill: "#FF7235"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1647 178.373L89.3484 167.86L83.1797 158.656L93.5211 162.22L98.8661 153.331L99.4197 164.151L110.735 165.422L100.664 170.376L103.992 181.156H102.229L94.2661 174.572L82.1647 178.373Z",
    fill: "#FF7235"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6652 157.043L70.2957 149.797L60.877 156.009L65.0634 145.655L57.7363 137.719L68.2007 139.443L73.0843 130.814L74.1335 140.133L83.8973 139.788L75.5279 146L78.6652 157.043Z",
    fill: "#FF7235"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2313 50.6343C89.1808 60.4403 81.9597 63.4531 81.9597 63.4531C76.8813 57.9719 67.6471 57.9719 66.263 65.7389C64.7286 74.3344 75.8525 76.3328 76.5361 76.671C76.5361 76.671 79.6118 92.5635 67.9923 98.65C62.5243 99.3263 52.9552 100.003 48.5125 101.355C45.2522 102.346 39.4664 104.821 34.6613 108.933C32.9526 107.026 19.9455 91.5288 32.1084 76.3328C40.5531 65.7761 54.4316 67.5852 54.4316 67.5852C53.9703 62.1006 53.0646 47.9393 65.0498 39.2593C77.035 30.5792 92.2942 35.1475 97.834 42.0016C99.8127 44.4463 100.876 47.2292 101.556 50.2217C97.3282 51.3275 91.2313 50.6343 91.2313 50.6343Z",
    fill: "#30242A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M144.151 81.8174C144.637 82.9265 145.136 84.1844 145.57 85.4625C145.57 85.4625 153.43 87.1532 155.545 92.3944",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M146.294 123.341L150.354 133.864",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M114.129 134.831L115.55 147.484",
    stroke: "#724342",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5983 91.2111C89.4556 90.7218 86.3898 89.833 83.477 88.5669",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3254 69.354L72.8827 66.6489",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9121 67.4429C54.165 69.9485 54.5068 73.083 54.8383 75.5582",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9625 73.4655L80.2065 80.9451C80.2612 81.2738 80.2296 81.6108 80.1149 81.924C80.0002 82.2371 79.8061 82.5158 79.5512 82.7334C79.2963 82.951 78.9891 83.1001 78.6592 83.1665C78.3294 83.2329 77.9878 83.2144 77.6672 83.1126L71.0099 80.9992C70.6892 80.8974 70.4004 80.7158 70.1711 80.4717C69.9418 80.2276 69.7797 79.9294 69.7004 79.6055C69.6212 79.2816 69.6274 78.943 69.7184 78.6222C69.8095 78.3014 69.9824 78.0091 70.2205 77.7734L75.6167 72.397C75.8723 72.1391 76.1954 71.9568 76.5499 71.8704C76.9043 71.784 77.2761 71.797 77.6234 71.908C77.9708 72.0189 78.2801 72.2234 78.5166 72.4985C78.7531 72.7736 78.9075 73.1085 78.9625 73.4655Z",
    fill: "#F4E6D8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9461 71.5781C95.2571 76.0483 99.9118 76.3527 101.005 73.1775L94.9461 71.5781Z",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1943 63.3311C95.0213 63.7335 97.9741 63.818 98.931 61.4814",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5124 101.355L48.6184 155.917C48.6184 155.917 82.2125 136.018 84.8098 135.859C86.7202 135.74 88.1419 140.021 84.6936 143.558C93.9893 141.85 103.227 140.954 104.679 143.754C105.554 145.445 104.129 147.203 104.129 147.203C105.243 147.342 106.33 147.633 106.952 148.356C108.445 150.091 106.395 152.752 106.395 152.752C108.288 153.655 107.635 156.472 105.927 157.824C101.747 161.128 89.2252 163.488 89.2252 163.488C93.7295 164.032 102.396 164.54 101.932 167.076C101.248 170.795 82.11 170.795 82.11 170.795C74.9332 175.529 69.0175 175.407 69.0175 175.407C69.0175 175.407 51.4925 193.207 33.8171 197.386C-11.6357 205.164 23.9064 120.967 33.4754 110.147C39.415 103.428 48.5124 101.355 48.5124 101.355Z",
    fill: "#A15842"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9934 164.26C89.6012 164.236 87.0106 164.226 84.3962 164.26",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.716 153.52C101.125 154.534 91.2484 156.404 84.0443 158.162",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M104.467 147.366C97.5401 148.302 87.5951 149.733 81.3205 151.062",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M83.952 143.159C81.4371 143.724 78.9603 144.443 76.536 145.313",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3697 125.113L29.0122 136.434L34.6476 126.161L44.7635 130.3L37.0912 119.946L43.0001 110.377L33.0312 113.758L31.8726 112.297C32.3636 111.546 32.9035 110.828 33.4891 110.147C39.4287 103.428 48.5261 101.355 48.5261 101.355L48.6047 141.898L45.5768 144.836L37.2074 135.767L41.4382 148.224L40.6966 148.765L17.6353 143.862C19.8335 137.264 22.3959 130.79 25.311 124.47L28.3697 125.113Z",
    fill: "#FFBE21"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110.366L37.0911 119.936L44.7634 130.289L34.6476 126.151L29.0121 136.433L28.3696 125.112L25.2939 124.467C27.7066 119.273 30.0169 115.019 31.8418 112.294L33.014 113.751L43 110.366Z",
    fill: "#FF7235"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4245 148.225L37.1937 135.764L45.5632 144.836L48.5911 141.898L48.6082 150.453L40.683 148.766L41.4245 148.225Z",
    fill: "#FF7235"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3019 134.337V154.656",
    stroke: "#724342",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4352 154.656C49.4352 154.656 42.8086 158.622 32.5561 164.709",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M167.086 68.7217C168.016 72.1335 168.843 76.9385 168.142 81.8685",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M159.845 65.6714C160.743 68.3427 161.694 72.9549 161.133 79.8056",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M151.96 64.3726C152.938 67.2095 154.247 71.6628 153.69 77.3503",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M144.158 67.1021C144.158 67.1021 144.257 69.1985 144.425 71.4979",
    stroke: "#30242A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.98d1d51a4955378a7f5b1b419a21c232.svg";
export { ForwardRef as ReactComponent };